import React from 'react'
import { motion } from 'framer-motion'
import { ShieldCheckIcon, AcademicCapIcon, ClockIcon, UserGroupIcon } from '../icons/FeatureIcons'

const features = [
  {
    icon: ShieldCheckIcon,
    title: 'DMV Licensed',
    description: 'Fully licensed and certified by Virginia DMV',
  },
  // {
  //   icon: AcademicCapIcon,
  //   title: '98% Pass Rate',
  //   description: 'Industry-leading first-attempt pass rate',
  // },
  {
    icon: ClockIcon,
    title: 'Flexible Schedule',
    description: 'Morning, evening, and weekend classes',
  },
  {
    icon: UserGroupIcon,
    title: 'Expert Instructors',
    description: 'Certified and experienced professionals',
  },
]

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
    },
  },
}

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
    },
  },
}

export default function WhyChooseUs() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <div className="text-accent font-heading font-semibold text-sm uppercase tracking-wider mb-2">
            Why Choose Us
          </div>
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-primary mb-4">
            The A Plus A Difference
          </h2>
          <p className="text-lg text-secondary-text max-w-2xl mx-auto">
            We&apos;re committed to providing the highest quality driver education in Virginia.
          </p>
        </motion.div>

        {/* Features Grid */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 justify-items-center max-w-4xl mx-auto"
        >
          {features.map((feature) => {
            const Icon = feature.icon
            return (
              <motion.div
                key={feature.title}
                variants={itemVariants}
                whileHover={{ y: -5, transition: { duration: 0.2 } }}
                className="bg-white p-6 rounded-lg shadow-soft text-center"
              >
                <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center mx-auto mb-4">
                  <Icon className="w-8 h-8 text-accent" />
                </div>
                <h3 className="text-xl font-heading font-bold text-primary mb-2">
                  {feature.title}
                </h3>
                <p className="text-secondary-text">
                  {feature.description}
                </p>
              </motion.div>
            )
          })}
        </motion.div>
      </div>
    </section>
  )
}

